module.exports = __webpack_public_path__ + "assets/img/jbm2.5c7ee21a.jpg";